import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from '@/api/utils'

export const setFlowCompleted = async <T extends Action<ACTION_TYPE.SET_FLOW_COMPLETED>>({ uniqueId }: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {
      uniqueId
    },
    type: ACTION_TYPE.SET_FLOW_COMPLETED
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const user = body.data

  return user
}

export const getPhysicianCountries = async <T extends Action<ACTION_TYPE.GET_PHYSICIAN_COUNTRIES>>(): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {},
    type: ACTION_TYPE.GET_PHYSICIAN_COUNTRIES
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const countries = body.data

  return countries
}

export const isWebsocketConnected = async <T extends Action<ACTION_TYPE.IS_WEBSOCKET_CONNECTED>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.IS_WEBSOCKET_CONNECTED
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}
